<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
	<div>
		<table mat-table [dataSource]="dataSource" matSort class="w-100">
			<ng-container matColumnDef="name">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong class="text-sm">Field Name</strong></th>
				<td mat-cell *matCellDef="let mdv">{{mdv.name}}</td>
			</ng-container>
			<ng-container matColumnDef="value">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong class="text-sm">Value</strong></th>
				<td mat-cell *matCellDef="let mdv">{{mdv.value}}</td>
			</ng-container>
			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let step; columns: displayedColumns;"></tr>
		</table>
	</div>
</mat-dialog-content>

<mat-dialog-actions >
	<div class="w-100 flex-row justify-end items-center mt-3 p-2">
		<a mat-button class="dialog-btn" color="primary" (click)="onConfirmClick()"><span class="text-bold">{{confirmButtonText}}</span></a>
	</div>
</mat-dialog-actions>
